import React,{useEffect} from 'react'
import {Route, Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import AuthLayout from 'layouts/Auth'
import Swal from 'sweetalert2'
const  AuthRoute = ({component:Component, authenticated, admin, coach, authChecked, loading, userDetails, ...rest}) => {
    
    return (
        <Route {...rest}
            render = {(props) => {
                // Only show loading if authentication is not yet checked and user is not authenticated
                // if ((!authChecked || loading) && !authenticated) {
                //     Swal.fire({
                //         title: 'Loading...',
                //         text: 'Checking authentication',
                //         allowOutsideClick: false,
                //         showConfirmButton: false,
                //         didOpen: () => {
                //             Swal.showLoading();
                //         }
                //     });
                //     return null;
                // } else {
                //     // Always close any existing Swal when auth check is complete or user is authenticated
                //     if (Swal.isVisible()) {
                //         Swal.close();
                //     }
                // }
                
                if (authenticated === true ){
                    // Debug: Check coach value
                    if (admin === true ){
                        return <Redirect to = "/admin/question-bank"/>
                    }else if(coach === true ){
                        return <Redirect to = "/client/question-bank/create-test"/>
                    } else {
                        // Wait for both authentication to be checked AND userDetails to be available
                        if (!authChecked || !userDetails || Object.keys(userDetails).length === 0) {
                            // Show loading while waiting for complete user data
                            return null;
                        }

                        // Default redirect to question bank for now
                        return <Redirect to = "/client/question-bank/create-test"/>

                        // Original redirect logic (commented out for now)
                        // let redirectUrl = "";
                        //
                        // if (userDetails.ultimateAdvisingStudent === true || userDetails.ultimateAdvisingStudent === "true") {
                        //     redirectUrl = "/client/community-uas";
                        // }
                        // // Check if user is Pro Member
                        // else if (userDetails.plan === "pro member") {
                        //     redirectUrl = "/client/community-pro-members";
                        // }
                        // else {
                        //     redirectUrl = "/client/community-free-members";
                        // }
                        //
                        // return <Redirect to = {redirectUrl}/>
                    }
                } else {
                    return <AuthLayout><Component {...props}/></AuthLayout>
                }
            }
            }
        />
)}
const mapStateToProps = (state) => ({
    authenticated: state.loginAuth.authenticated,
    admin: state.loginAuth.admin,
    coach: state.loginAuth.userDetails?.coach,
    authChecked: state.loginAuth.authChecked,
    loading: state.loginAuth.loading,
    userDetails: state.loginAuth.userDetails
})

export default connect(mapStateToProps)(AuthRoute)
